import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
const ClientVisibilityControl = _ref => {
  let {
    report,
    fieldName,
    handleChange,
    handleSubmit,
    disabled
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-3",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: 6
  }, t('client_visibility')), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "select",
    name: fieldName,
    object: report,
    value: report[fieldName],
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: "not_visible"
  }, t('not_visible_to_client')), /*#__PURE__*/React.createElement("option", {
    value: "visible"
  }, t('visible_to_client')), /*#__PURE__*/React.createElement("option", {
    value: "custom"
  }, t('select_sections_to_show'))))), /*#__PURE__*/React.createElement("hr", null));
};
export default ClientVisibilityControl;